import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { _className, AwaitModules, ComponentSync, Grid, LL_H_C, LL_V_L, scrollIntoView, } from '@nu-art/thunderstorm-frontend/index';
import { sortArray } from '@nu-art/ts-common';
import './Manager_HealthcareSpace.scss';
import { Manager_Variable } from '../Manager_Variable/Manager_Variable.js';
import { ModuleFE_Discussion, ModuleFE_Reference, ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable } from '../../_entity.js';
import React from 'react';
const modulesToAwait = [ModuleFE_Tag, ModuleFE_Variable, ModuleFE_Value, ModuleFE_Reference];
class Manager_HealthcareSpace_Class extends ComponentSync {
    // ######################## Static ########################
    variablesContainerRef = React.createRef();
    selectedVarRef = React.createRef();
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        const firstDerive = !this.state?.tagId;
        state.tagId = nextProps.tagId;
        if (this.state?.tagId !== state.tagId)
            state.selectedVarId = undefined;
        state.variableContainerHeight = this.variablesContainerRef?.current?.clientHeight ?? 0;
        //If a var id is given
        if (nextProps.varId) {
            //If not the first derive or the var id hasn't changed
            if (!firstDerive && this.props.varId === nextProps.varId)
                return state;
            state.selectedVarId = nextProps.varId;
        }
        return state;
    }
    componentDidUpdate(prevProps, prevState) {
        //If this is the first render after getting a ref for the variables container
        if (!this.state.variableContainerHeight && this.variablesContainerRef?.current) {
            this.setState({ variableContainerHeight: this.variablesContainerRef.current.clientHeight });
        }
        //If selected var has changed, scroll
        if (this.state.selectedVarId && this.state.selectedVarId !== prevState.selectedVarId) {
            scrollIntoView(this.selectedVarRef, this.variablesContainerRef);
        }
    }
    // ######################## Logic ########################
    getVariablesForTagId = (tagId) => {
        return sortArray(ModuleFE_Variable.cache.filter(variable => {
            return !!variable.tagIds.find(group => group.key === tagId || group.value.includes(tagId));
        }), variable => variable.name.toLowerCase());
    };
    onVarClick = (varId) => {
        this.setState({ selectedVarId: varId });
    };
    // ######################## Render ########################
    render() {
        return _jsxs(Grid, { id: 'manager__hcs', className: 'quai-item-manager', children: [this.renderHeader(), this.renderVariables(), this.renderVariableInfo()] });
    }
    // ######################## Render - Header ########################
    renderHeader = () => {
        const tag = ModuleFE_Tag.cache.unique(this.state.tagId);
        let hierarchy = 'Healthcare Space';
        tag.tagIds.forEach(tagId => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            hierarchy += ` > ${tag.label}`;
        });
        return _jsx(LL_H_C, { className: 'manager__header', children: _jsxs(LL_V_L, { className: 'manager__header__main', children: [_jsx(LL_H_C, { className: 'manager__header__title', children: _jsx("div", { className: 'manager__header__title__label', children: tag?.label }) }), _jsxs(LL_H_C, { className: 'manager__header__sub-title', children: [_jsx("span", { className: 'manager__header__sub-title__item', children: "Tag" }), "in", _jsx("span", { className: 'manager__header__sub-title__hierarchy', children: hierarchy })] })] }) });
    };
    // ######################## Render - Body ########################
    renderVariables = () => {
        const variables = this.getVariablesForTagId(this.state.tagId);
        return _jsx(LL_V_L, { className: 'manager__hcs__variables', innerRef: this.variablesContainerRef, children: variables.map(this.renderVariable) });
    };
    renderVariable = (variable) => {
        const className = _className('manager__hcs__variable', this.state.selectedVarId === variable._id && 'selected', ModuleFE_Discussion.hasUnresolvedDiscussions(variable._id, ModuleFE_Variable.dbDef.dbKey) && 'open-discussion');
        return _jsx("div", { className: className, onClick: () => this.onVarClick(variable._id), ref: variable._id === this.state.selectedVarId ? this.selectedVarRef : undefined, children: variable.name }, variable._id);
    };
    renderVariableInfo = () => {
        if (!this.state.selectedVarId)
            return;
        return _jsx(Manager_Variable, { varId: this.state.selectedVarId });
    };
}
export const Manager_HealthcareSpace = (props) => {
    return _jsx(AwaitModules, { modules: modulesToAwait, children: _jsx(Manager_HealthcareSpace_Class, { ...props }) });
};
//# sourceMappingURL=Manager_HealthcareSpace.js.map